import request from "./request";

const CategoryService = {
    GetAll: async (context, signal) => {
        return await request.sendRequest(`/category/select/all`, context.token, signal);
    },
    GetAllCategories: async (context, signal) => {
        return await request.sendRequest(`/category/all`, context.token, signal);
    },
    Save: async (payload, context, signal) => {
        return await request.sendPostRequest(`/category`, payload, context, signal);
    },
    Remove: async (id, context) => {
        return await request.sendDeleteRequest(`/category/${id}`, context.token);
    },
};

export default CategoryService;
